// App shell — mounts the Layout (fixed nav + page background) and renders
// each marketing section in scroll order. Sections are full-page anchors so
// the nav can scroll-spy and link directly to them.
import { Layout } from "./components/layout/Layout";
import { Hero } from "./components/sections/Hero";
import { Capabilities } from "./components/sections/Capabilities";
import { About } from "./components/sections/About";
import { Contact } from "./components/sections/Contact";

export function App() {
  return (
    <Layout>
      <Hero />
      <Capabilities />
      <About />
      <Contact />
    </Layout>
  );
}
